import GallerySlice from 'containers/Slices/GallerySlice';

export const seriesGalleryTab = (block, type, index) => {
  switch (type) {
    case 'gallery_tab':
      return <GallerySlice block={block} key={`${type}-${index}`} />;
    default:
      return '';
  }
};
